import React from 'react';
import Icon from '../common/Icons';
import AdminRowActionMenu from './ui/AdminRowActionMenu';
import SiteCareModeBadge from '../sites/SiteCareModeBadge';
import { isCentralSite } from '../sites/siteListUtils';
import { SITE_CARE_MODES } from '../../constants/siteCareModes';

function getSiteInitials(site) {
  const name = (site?.name || '').trim();
  if (!name) return 'S';
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export default function SiteRowActionMenu({
  anchorEl,
  site,
  onClose,
  onEdit,
  onToggleStatus,
  onDelete,
  disabled = false
}) {
  if (!site || !anchorEl) return null;

  const central = isCentralSite(site);
  const hasPharmacy =
    site.has_local_pharmacy || site.site_care_mode === SITE_CARE_MODES.WITH_PHARMACY;

  const badges = [
    {
      label: site.is_active ? 'Actif' : 'Inactif',
      variant: site.is_active ? 'active' : 'inactive'
    }
  ];
  if (central) badges.push({ label: 'Centrale', variant: 'accent' });

  return (
    <AdminRowActionMenu
      anchorEl={anchorEl}
      onClose={onClose}
      theme="teal"
      title={site.name}
      subtitle={site.address || 'Adresse non renseignée'}
      initials={getSiteInitials(site)}
      badges={badges}
      disabled={disabled}
      items={[
        {
          id: 'edit',
          label: 'Modifier',
          hint: 'Fiche du site',
          icon: 'edit',
          tone: 'primary',
          onClick: () => {
            onClose();
            onEdit(site);
          }
        },
        {
          id: 'toggle',
          label: site.is_active ? 'Désactiver' : 'Réactiver',
          hint: site.is_active ? 'Hors service temporaire' : 'Remettre en service',
          icon: site.is_active ? 'eyeSlash' : 'checkCircle',
          tone: 'warn',
          onClick: () => {
            onToggleStatus(site);
            onClose();
          }
        }
      ]}
      extra={
        <>
          <SiteCareModeBadge mode={site.site_care_mode} variant="compact" showIcon={false} />
          <span className={`st-pharmacy-pill ${hasPharmacy ? 'st-pharmacy-pill--yes' : 'st-pharmacy-pill--no'}`}>
            Pharmacie {hasPharmacy ? 'oui' : 'non'}
          </span>
        </>
      }
      footer={
        central ? (
          <p className="adm-row-menu__footer-hint">
            La pharmacie centrale ne peut pas être supprimée depuis cette page.
          </p>
        ) : (
          <button
            type="button"
            role="menuitem"
            className="adm-row-menu__item adm-row-menu__item--danger"
            disabled={disabled}
            onClick={() => {
              onDelete(site);
              onClose();
            }}
          >
            <span className="adm-row-menu__icon adm-row-menu__icon--danger" aria-hidden>
              <Icon name="trash" size={15} />
            </span>
            <span className="adm-row-menu__item-text">
              <span className="adm-row-menu__item-label">Supprimer le site</span>
              <span className="adm-row-menu__item-hint">Action irréversible</span>
            </span>
          </button>
        )
      }
    />
  );
}
